module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAHlBMVEVHcEy8bzy+cUC+ckG+ckC+cUG+ckG/ckC+cUC/cT9DpHcmAAAACnRSTlMADS7/iai6asskpk9ecAAAAEZJREFUeNq90jsSACAIQ0EE8XP/CztWdK8Ax7Q7pCHyJ01RzTqwGrvXvA12uT7hvurrge8ER3lSR16FlV/iBdVQmCIN+XMORisBzMVgfEgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/right.png
// module id = WXLO
// module chunks = 215